// Mocaverse NFT data
   export const captainzNFTs = [

  {
    id: 'the-captainz-9924',
    name: 'The Captainz #9924',
    image: 'https://captainz-api.memeland.com/images/81a899e6-ca78-420d-a239-cc3cba572441/9924.png',
    price: 1.54
  },
  {
    id: 'the-captainz-9945',
    name: 'The Captainz #9945',
    image: 'https://captainz-api.memeland.com/images/f6957d3e-516c-4e5a-8cef-36b15e38757c/9945.png',
    price: 1.54
  },
       
  {
    id: 'the-captainz-9946',
    name: 'The Captainz #9946',
    image: 'https://api.memeland.com/captainz/images/human.gif',
    price: 1.54
  },
  {
    id: 'the-captainz-9952',
    name: 'The Captainz #9952',
    image: 'https://captainz-api.memeland.com/images/72078d5c-ada1-4edc-8230-c330f4015da2/9952.png',
    price: 1.68
  },
  {
    id: 'the-captainz-9953',
    name: 'The Captainz #9953',
    image: 'https://captainz-api.memeland.com/images/3bf6dff7-4a22-4866-bc5f-dec3de297ff1/9953.png',
    price: 1.82
  },
  {
    id: 'the-captainz-9954',
    name: 'The Captainz #9954',
    image: 'https://captainz-api.memeland.com/images/07722c56-6cc1-4da5-878b-05668e8b2756/9954.png',
    price: 1.95
  },
  {
    id: 'the-captainz-9955',
    name: 'The Captainz #9955',
    image: 'https://captainz-api.memeland.com/images/89b30b18-a3dd-43f3-a3db-5a997e48352b/9955.png',
    price: 2.08
  },
  {
    id: 'the-captainz-9956',
    name: 'The Captainz #9956',
    image: 'https://captainz-api.memeland.com/images/3ba5460e-d6b1-42f1-929e-d02bd761af6d/9956.png',
    price: 2.15
  },
  {
    id: 'the-captainz-9958',
    name: 'The Captainz #9958',
    image: 'https://captainz-api.memeland.com/images/b3b63be2-e0eb-4fd2-a04a-8cc8afb0cd47/9958.png',
    price: 2.22
  },
  {
    id: 'the-captainz-9959',
    name: 'The Captainz #9959',
    image: 'https://captainz-api.memeland.com/images/b530027e-1034-4db9-aed6-c91cd6b26555/9959.png',
    price: 2.30
  },
  {
    id: 'the-captainz-9960',
    name: 'The Captainz #9960',
    image: 'https://api.memeland.com/captainz/images/human.gif',
    price: 1.75
  },
  {
    id: 'the-captainz-9961',
    name: 'The Captainz #9961',
    image: 'https://captainz-api.memeland.com/images/92907e89-44df-4e5a-8455-5eae7d61fe76/9961.png',
    price: 1.89
  },
  {
    id: 'the-captainz-9962',
    name: 'The Captainz #9962',
    image: 'https://captainz-api.memeland.com/images/0fd7b782-097e-4f7e-8652-e3bff45a2b5a/9962.png',
    price: 2.05
  },
  {
    id: 'the-captainz-9963',
    name: 'The Captainz #9963',
    image: 'https://captainz-api.memeland.com/images/dc8a9877-54b6-4e5c-beea-8b6c28c1c390/9963.png',
    price: 2.18
  },
  {
    id: 'the-captainz-9964',
    name: 'The Captainz #9964',
    image: 'https://captainz-api.memeland.com/images/3d669621-014d-4e62-887e-3d0ce32dc9f9/9964.png',
    price: 1.67
  },
  {
    id: 'the-captainz-9965',
    name: 'The Captainz #9965',
    image: 'https://captainz-api.memeland.com/images/1c978a21-c130-49ee-83d5-8026741868b1/9965.png',
    price: 1.85
  },
  {
    id: 'the-captainz-9966',
    name: 'The Captainz #9966',
    image: 'https://captainz-api.memeland.com/images/48d84861-f069-4975-9e51-c82e1141742f/9966.png',
    price: 2.1
  },
  {
    id: 'the-captainz-9967',
    name: 'The Captainz #9967',
    image: 'https://captainz-api.memeland.com/images/06e85e9c-8687-4037-8db5-11af4a1e691c/9967.png',
    price: 1.95
  },
  {
    id: 'the-captainz-9968',
    name: 'The Captainz #9968',
    image: 'https://api.memeland.com/captainz/images/human.gif',
    price: 2.25
  },
  {
    id: 'the-captainz-9970',
    name: 'The Captainz #9970',
    image: 'https://api.memeland.com/captainz/images/human.gif',
    price: 1.78
  },
  {
    id: 'the-captainz-9971',
    name: 'The Captainz #9971',
    image: 'https://captainz-api.memeland.com/images/c5003a77-a346-488a-b8cd-5d2974dcf392/9971.png',
    price: 2.15
  },
  {
    id: 'the-captainz-9972',
    name: 'The Captainz #9972',
    image: 'https://api.memeland.com/captainz/images/human.gif',
    price: 1.92
  },
  {
    id: 'the-captainz-9976',
    name: 'The Captainz #9976',
    image: 'https://captainz-api.memeland.com/images/55d703e8-b076-4815-9696-2fdd527180e5/9976.png',
    price: 2.3
  },
  {
    id: 'the-captainz-9978',
    name: 'The Captainz #9978',
    image: 'https://captainz-api.memeland.com/images/f887a8ee-c26f-4892-90af-ee1ea47f250e/9978.png',
    price: 1.54
  },
  {
    id: 'the-captainz-9980',
    name: 'The Captainz #9980',
    image: 'https://captainz-api.memeland.com/images/76b98d13-d298-4884-af6d-0eb8cb9b4f6b/9980.png',
    price: 1.88
  },
  {
    id: 'the-captainz-9982',
    name: 'The Captainz #9982',
    image: 'https://captainz-api.memeland.com/images/bb0296c2-62cf-42ce-b418-9bf7075baf54/9982.png',
    price: 2.05
  },
  {
    id: 'the-captainz-9983',
    name: 'The Captainz #9983',
    image: 'https://api.memeland.com/captainz/images/human.gif',
    price: 2.45
  },
  {
    id: 'the-captainz-9984',
    name: 'The Captainz #9984',
    image: 'https://captainz-api.memeland.com/images/0b7d5895-4f9f-45ce-9f67-4b97f849d39b/9984.png',
    price: 2.65
  },
  {
    id: 'the-captainz-9985',
    name: 'The Captainz #9985',
    image: 'https://captainz-api.memeland.com/images/09142ae0-6a8e-4bfb-b0b0-0bf150ebca68/9985.png',
    price: 2.85
  },
  {
    id: 'the-captainz-9986',
    name: 'The Captainz #9986',
    image: 'https://captainz-api.memeland.com/images/e2c5100f-e903-49f9-92c9-387bf9e51ad7/9986.png',
    price: 2.30
  },
  {
    id: 'the-captainz-9987',
    name: 'The Captainz #9987',
    image: 'https://api.memeland.com/captainz/images/human.gif',
    price: 2.75
  },
  {
    id: 'the-captainz-9988',
    name: 'The Captainz #9988',
    image: 'https://captainz-api.memeland.com/images/a3e84c45-5750-4718-bf49-bbe774ccb963/9988.png',
    price: 2.95
  },
  {
    id: 'the-captainz-9990',
    name: 'The Captainz #9990',
    image: 'https://captainz-api.memeland.com/images/e1baf95b-5d95-46e4-8b5c-12c250846f63/9990.png',
    price: 2.50
  },
  {
    id: 'the-captainz-9993',
    name: 'The Captainz #9993',
    image: 'https://captainz-api.memeland.com/images/30a9d102-bdc4-4eee-8af3-097ffbc37bd2/9993.png',
    price: 2.80
  },
  {
    id: 'the-captainz-9995',
    name: 'The Captainz #9995',
    image: 'https://captainz-api.memeland.com/images/202fa0a4-7567-4e1d-9f7c-eeab95417977/9995.png',
    price: 2.90
  },
  {
    id: 'the-captainz-9996',
    name: 'The Captainz #9996',
    image: 'https://captainz-api.memeland.com/images/d01e72ca-6b0e-4882-819f-b3c301f2774c/9996.png',
    price: 3.00
  },
  {
    id: 'the-captainz-9997',
    name: 'The Captainz #9997',
    image: 'https://api.memeland.com/captainz/images/kraken.gif',
    price: 2.70
  },
  {
    id: 'the-captainz-9998',
    name: 'The Captainz #9998',
    image: 'https://captainz-api.memeland.com/images/4d311bb4-4c2b-4ebf-80de-64632257c054/9998.png',
    price: 2.60
  },
       
  {
    id: 'the-captainz-9924',
    name: 'The Captainz #9924',
    image: 'https://captainz-api.memeland.com/images/81a899e6-ca78-420d-a239-cc3cba572441/9924.png',
    price: 1.54
  },
  {
    id: 'the-captainz-9945',
    name: 'The Captainz #9945',
    image: 'https://captainz-api.memeland.com/images/f6957d3e-516c-4e5a-8cef-36b15e38757c/9945.png',
    price: 2.15
  },
  {
    id: 'the-captainz-9946',
    name: 'The Captainz #9946',
    image: 'https://api.memeland.com/captainz/images/human.gif',
    price: 3.25
  },
  {
    id: 'the-captainz-9952',
    name: 'The Captainz #9952',
    image: 'https://captainz-api.memeland.com/images/72078d5c-ada1-4edc-8230-c330f4015da2/9952.png',
    price: 2.75
  },
  {
    id: 'the-captainz-9953',
    name: 'The Captainz #9953',
    image: 'https://captainz-api.memeland.com/images/3bf6dff7-4a22-4866-bc5f-dec3de297ff1/9953.png',
    price: 3.45
  },
  {
    id: 'the-captainz-9954',
    name: 'The Captainz #9954',
    image: 'https://captainz-api.memeland.com/images/07722c56-6cc1-4da5-878b-05668e8b2756/9954.png',
    price: 1.95
  },
  {
    id: 'the-captainz-9955',
    name: 'The Captainz #9955',
    image: 'https://captainz-api.memeland.com/images/89b30b18-a3dd-43f3-a3db-5a997e48352b/9955.png',
    price: 2.45
  },
  {
    id: 'the-captainz-9956',
    name: 'The Captainz #9956',
    image: 'https://captainz-api.memeland.com/images/3ba5460e-d6b1-42f1-929e-d02bd761af6d/9956.png',
    price: 3.85
  },
  {
    id: 'the-captainz-9958',
    name: 'The Captainz #9958',
    image: 'https://captainz-api.memeland.com/images/b3b63be2-e0eb-4fd2-a04a-8cc8afb0cd47/9958.png',
    price: 4.2
  },
  {
    id: 'the-captainz-9959',
    name: 'The Captainz #9959',
    image: 'https://captainz-api.memeland.com/images/b530027e-1034-4db9-aed6-c91cd6b26555/9959.png',
    price: 2.95
  },
  {
    id: 'the-captainz-9960',
    name: 'The Captainz #9960',
    image: 'https://api.memeland.com/captainz/images/human.gif',
    price: 3.65
  },
  {
    id: 'the-captainz-9961',
    name: 'The Captainz #9961',
    image: 'https://captainz-api.memeland.com/images/92907e89-44df-4e5a-8455-5eae7d61fe76/9961.png',
    price: 4.1
  },
  {
    id: 'the-captainz-9962',
    name: 'The Captainz #9962',
    image: 'https://captainz-api.memeland.com/images/0fd7b782-097e-4f7e-8652-e3bff45a2b5a/9962.png',
    price: 2.35
  },
  {
    id: 'the-captainz-9963',
    name: 'The Captainz #9963',
    image: 'https://captainz-api.memeland.com/images/dc8a9877-54b6-4e5c-beea-8b6c28c1c390/9963.png',
    price: 1.85
  },
  {
    id: 'the-captainz-9964',
    name: 'The Captainz #9964',
    image: 'https://captainz-api.memeland.com/images/3d669621-014d-4e62-887e-3d0ce32dc9f9/9964.png',
    price: 3.15
  },
  {
    id: 'the-captainz-9965',
    name: 'The Captainz #9965',
    image: 'https://captainz-api.memeland.com/images/1c978a21-c130-49ee-83d5-8026741868b1/9965.png',
    price: 2.65
  },
  {
    id: 'the-captainz-9966',
    name: 'The Captainz #9966',
    image: 'https://captainz-api.memeland.com/images/48d84861-f069-4975-9e51-c82e1141742f/9966.png',
    price: 4.3
  },
  {
    id: 'the-captainz-9967',
    name: 'The Captainz #9967',
    image: 'https://captainz-api.memeland.com/images/06e85e9c-8687-4037-8db5-11af4a1e691c/9967.png',
    price: 3.75
  },
  {
    id: 'the-captainz-9968',
    name: 'The Captainz #9968',
    image: 'https://api.memeland.com/captainz/images/human.gif',
    price: 2.85
  },
  {
    id: 'the-captainz-9970',
    name: 'The Captainz #9970',
    image: 'https://api.memeland.com/captainz/images/human.gif',
    price: 4.5
  },
  {
    id: 'the-captainz-9971',
    name: 'The Captainz #9971',
    image: 'https://captainz-api.memeland.com/images/c5003a77-a346-488a-b8cd-5d2974dcf392/9971.png',
    price: 3.95
  },
  {
    id: 'the-captainz-9972',
    name: 'The Captainz #9972',
    image: 'https://api.memeland.com/captainz/images/human.gif',
    price: 2.25
  },
  {
    id: 'the-captainz-9973',
    name: 'The Captainz #9973',
    image: 'https://api.memeland.com/captainz/images/human.gif',
    price: 1.75
  },
  {
    id: 'the-captainz-9974',
    name: 'The Captainz #9974',
    image: 'https://api.memeland.com/captainz/images/human.gif',
    price: 4.15
  },
  {
    id: 'the-captainz-9975',
    name: 'The Captainz #9975',
    image: 'https://api.memeland.com/captainz/images/human.gif',
    price: 3.55
  },
  {
    id: 'the-captainz-9976',
    name: 'The Captainz #9976',
    image: 'https://captainz-api.memeland.com/images/55d703e8-b076-4815-9696-2fdd527180e5/9976.png',
    price: 2.55
  },
  {
    id: 'the-captainz-9977',
    name: 'The Captainz #9977',
    image: 'https://api.memeland.com/captainz/images/human.gif',
    price: 4.45
  },
  {
    id: 'the-captainz-9978',
    name: 'The Captainz #9978',
    image: 'https://captainz-api.memeland.com/images/f887a8ee-c26f-4892-90af-ee1ea47f250e/9978.png',
    price: 3.35
  },
  {
    id: 'the-captainz-9979',
    name: 'The Captainz #9979',
    image: 'https://api.memeland.com/captainz/images/human.gif',
    price: 1.65
  },
  {
    id: 'the-captainz-9980',
    name: 'The Captainz #9980',
    image: 'https://captainz-api.memeland.com/images/76b98d13-d298-4884-af6d-0eb8cb9b4f6b/9980.png',
    price: 4.7
  },
  {
    id: 'the-captainz-9981',
    name: 'The Captainz #9981',
    image: 'https://api.memeland.com/captainz/images/human.gif',
    price: 2.05
  }


    
];
